export enum TypeAttendance {
	ELECTIVE = 'ELETIVA',
	EMERGENCY = 'URGENCIA',
	SURGERY = 'CIRURGIA',
}
